export enum RoadPricingType {
  DISCOUNT = 'discount',
  COMMISSION = 'commission',
}
